import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styles from '../../../styles';
import { withLocal } from '../../common/LocaleProvider/LocaleProvider';
import { useProfile, useResult } from '../../../hooks';
import { getDisplaydate } from '../../../utils/date-utils';
import { Checkmark, DateView } from '../../common';
import risk from '../../../constants/risk';
import routes from '../../../constants/routes';

const useStyles = makeStyles({
  root: {
    ...styles.statusPageRoot,
    padding: '8px',
    backgroundColor: '#00a791',
    fontSize: '20px',
    '& > p': {
      textAlign: 'center'
    }
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontWeight: '500',
    fontSize: '48px',
    minHeight: '130px'
  }
});

const Approved = ({ history, locale }) => {
  const classes = useStyles();

  const [displayDate, setDisplayDate] = useState({
    colors: {}
  });
  const { profile } = useProfile();
  const { result } = useResult();
  const locState = history.location.state;
  const { cat, date, temp } = locState || result;

  useEffect(() => {
    if (cat !== risk.NO) {
      history.push(routes.HOME_PAGE);
    }
  }, [cat, history]);

  useEffect(() => {
    if (date) {
      setDisplayDate({ ...getDisplaydate(date, locale) });
    }
  }, [date, locale]);

  return (
    <div
      className={classes.root}
      style={{
        backgroundColor: displayDate.colors.background,
        color: displayDate.colors.font
      }}
    >
      <span
        style={{
          fontWeight: '500',
          fontSize: '1rem',
          marginBottom: '16px',
          textAlign: 'center'
        }}
      >
        {locale.result.screenshot}
      </span>
      <DateView displayDate={displayDate} />
      <Checkmark color={displayDate.colors.font} />
      <span style={{ fontSize: '20px' }}>
        {locale.result.temp}
        {temp && temp !== 'not provided' ? `${temp} \xB0F` : 'not provided'}
      </span>
      {profile && (
        <span style={{ marginBottom: '8px' }}>
          {locale.approved.good}
          {`${profile.firstName}!`}
        </span>
      )}
      <p style={{ marginTop: '0px', fontSize: '18px' }}>
        {displayDate.message}
      </p>
      <span style={{ fontWeight: '700' }}>#AscensionStrong</span>
    </div>
  );
};

export default withLocal(Approved);
